import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import logo from "../../Images/CommonImage/logo_aws_tp.png";
import { WatchListPopup } from "../PopUp_Component/Watchlistpopup/WatchListPopup";
import { useSelector } from "react-redux";
import { CommonBaseURl } from "../../Commonprovider/CommonProvider";
import { Container } from "react-bootstrap";
import Inner_Loader from "../Inner_Loader/Inner_Loader";
import Data_NotFound from "../Data_NotFound/Data_NotFound";
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  MasterDetailModule,
  MenuModule,
  ColumnsToolPanelModule,
]);
export const Watchlist = () => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);
  const navigate = useNavigate();
  const [showWatchlistPopup, setShowWatchlistPopup] = useState(false);
  const UserDetails = useSelector((state) => state.LoginUserDetails.data);
  const Token = useSelector((state) => state.Authenticationapi.token);
  const NoOfDigit = useSelector(state => state.LocalValuesData.NoOfDigit)
  const [Loader, setLoader] = useState(true);
  const [NoDataAvailable, setNoDataAvailable] = useState(false);

  const [BaseURL] = useState(CommonBaseURl);
  const [columnDefs, setColumnDefs] = useState([]);
  const UserId = UserDetails[0].UserId || JSON.parse(UserDetails)[0].UserId || "";
  const watchlistName = `${UserId}_watchlist`;
  const [watchlistData, setWatchlistData] = useState([]);
  let [saveChanges, setSaveChanges] = useState(false);

  const formatDateString = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
    return `${formattedDay}/${formattedMonth}/${year}`;
  };

  // const getColumnDefs = () => {
  //   return [
  //     {
  //       headerName: "Sr.No",
  //       width: 90,
  //       pinned: "left",
  //       sortable: false,
  //       valueGetter: (params) => params.node.rowIndex + 1,
  //       filter: true,
  //       flex: 1,
  //     },
  //     {
  //       headerName: "Company Name",
  //       field: "LNAME",
  //       // maxWidth: 300,
  //       cellStyle: { textAlign: "left" },
  //       flex: 1, // takes more space
  //       minWidth: 250,
  //       filter: true
  //     },
  //     {
  //       headerName: "Date of Addition",
  //       field: "PDATE",
  //       valueGetter: (params) => formatDateString(params.data.PDATE),
  //       filter: "agNumberColumnFilter",
  //       // minWidth: 100,
  //       flex: 1,
  //     },
  //     {
  //       headerName: "Price as on Date of Addition",
  //       field: "PCLOSE",
  //       headerClass: 'header-right-align',
  //       filter: "agNumberColumnFilter",
  //       cellStyle: { textAlign: "right" },
  //       // minWidth: 100,
  //       flex: 1,
  //     },
  //     {
  //       headerName: "Latest Date",
  //       field: "CDATE",
  //       valueGetter: (params) => formatDateString(params.data.CDATE),
  //       filter: "agNumberColumnFilter",
  //       // minWidth: 100,
  //       flex: 1,
  //     },
  //     {
  //       headerName: "Latest Price",
  //       field: "CCLOSE",
  //       // flex: 1,
  //       // minWidth: 100,
  //       flex: 1,
  //       headerClass: 'header-right-align',
  //       cellStyle: { textAlign: "right" },
  //       filter: "agNumberColumnFilter",
  //     },
  //     {
  //       headerName: "Change",
  //       valueGetter: (params) =>
  //         (params.data.CCLOSE - params.data.PCLOSE).toFixed(NoOfDigit),
  //       headerClass: 'header-right-align',
  //       cellStyle: { textAlign: "right" },
  //       filter: "agNumberColumnFilter",
  //       // minWidth: 100,
  //       flex: 1,
  //     },
  //     {
  //       headerName: "% Change",
  //       field: "ARETURN",
  //       valueFormatter: (params) => params.value.toFixed(NoOfDigit),
  //       headerClass: 'header-right-align',
  //       cellStyle: { textAlign: "right" },
  //       filter: "agNumberColumnFilter",
  //       // minWidth: 100,
  //       flex: 1,
  //     },

  //   ];
  // };

  const getColumnDefs = () => [
    {
      headerName: "Sr.No",
      maxWidth: 90, // ✅ instead of width
      pinned: "left",
      sortable: false,
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      headerName: "Company Name",
      field: "LNAME",
      flex: 3, // 👈 give more weight
      minWidth: 200,
      cellStyle: { textAlign: "left" },
      filter: true
    },
    {
      headerName: "Date of Addition",
      field: "PDATE",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => formatDateString(params.data.PDATE),
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Price as on Date of Addition",
      field: "PCLOSE",
      flex: 1,
      minWidth: 180,
      headerClass: "header-right-align",
      cellStyle: { textAlign: "right" },
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Latest Date",
      field: "CDATE",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => formatDateString(params.data.CDATE),
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Latest Price",
      field: "CCLOSE",
      flex: 1,
      minWidth: 120,
      headerClass: "header-right-align",
      cellStyle: { textAlign: "right" },
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Change",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) =>
        params.data.CCLOSE - params.data.PCLOSE, // ✅ number
      valueFormatter: (params) =>
        params.value.toFixed(NoOfDigit),
      headerClass: "header-right-align",
      cellStyle: { textAlign: "right" },
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "% Change",
      field: "ARETURN",
      flex: 1,
      minWidth: 120,
      valueFormatter: (params) =>
        params.value.toFixed(NoOfDigit),
      headerClass: "header-right-align",
      cellStyle: { textAlign: "right" },
      filter: "agNumberColumnFilter",
    },
  ]

  const showSavedWatchlistPopup = () => {
    setLoader(true);
    if (Token != null) {
      fetch(
        `${BaseURL}GetWatchList?UserID=${UserId}&WListName=${watchlistName}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + Token.access_token,
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let data = JSON.parse(json);
          if (data.length === 0) {
            setLoader(false);
            setNoDataAvailable(true);
          } else {
            setLoader(false);
            setNoDataAvailable(false);
            setWatchlistData(data);
          }
        });
    }
  };

  useEffect(() => {
    showSavedWatchlistPopup();
  }, [UserId, watchlistName, saveChanges]);

  useEffect(() => {
    setColumnDefs(getColumnDefs());

  }, [watchlistData]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "persist:root") {
        try {
          const persistRootRaw = localStorage.getItem("persist:root");
          if (!persistRootRaw) return;

          const persistRoot = JSON.parse(persistRootRaw);
          const authApiRaw = persistRoot.Authenticationapi;
          const authApi = JSON.parse(authApiRaw);

          const token = authApi?.token?.access_token;

          if (!token) {
            navigate("/", { replace: true });
          }
        } catch (error) {
          navigate("/", { replace: true });
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [navigate]);

  localStorage.setItem("logout-event", Date.now());

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "logout-event") {
        navigate("/", { replace: true });
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [navigate]);

  // const checkAuth = () => {
  //   if (!Token) {
  //     navigate("/login");
  //     window.location.reload();
  //   }
  // };

  // useEffect(() => {
  //   checkAuth();
  //   const interval = setInterval(checkAuth, 3000);
  //   return () => clearInterval(interval);

  // }, [Token, navigate]);

  return (
    <div>
      <div className="common-header">
        <Container fluid>
          <div className="header-desktop">
            <div className="logo-container">
              <img src={logo} alt="" className="img-fluid" />
            </div>
            <div className="user-details">
              <div className="common-dropdown">
                {/* Welcome  {JSON.parse(UserDetails)?.length != 0 ? JSON.parse(UserDetails)[0]?.UserName : ''} */}
              </div>
              <div className="user-img">
                {/* <!-- <img src="" alt="" className="img-fluid"> --> */}
              </div>
            </div>
          </div>
        </Container>
      </div>

      <div className="landing-box w-100">
        <div className="landing-box-head">
          <h5>My WatchList Data</h5>

          <button
            type="button"
            className="bttn"
            onClick={() => setShowWatchlistPopup(true)}
          >
            {" "}
            My WatchList +{" "}
          </button>
        </div>
        <div className="landing-box-body">
          {Loader ? (
            <Inner_Loader />
          ) : NoDataAvailable ? (
            <Data_NotFound />
          ) : (
            // <div className="table-responsive common-table seperatetable">
            //   <table className="table ">
            //     <thead>
            //       <tr>
            //         <th>Sr.No</th>
            //         <th>Company Name</th>
            //         <th>Date of Addition</th>
            //         <th>Price as on Date of Addition</th>
            //         <th>Latest Date</th>
            //         <th>Latest Price</th>
            //         <th>Change</th>
            //         <th>% Change</th>
            //       </tr>
            //     </thead>
            //     <tbody>
            //       {watchlistData.map((alertData, key) => (
            //         <tr key={key}>
            //           <th scope="row">{key + 1}</th>
            //           <td style={{ textAlign: "left" }}>{alertData.LNAME}</td>
            //           <td>{formatDateString(alertData.PDATE)}</td>
            //           <td>{alertData.PCLOSE}</td>
            //           <td>{formatDateString(alertData.CDATE)}</td>
            //           <td>{alertData.CCLOSE}</td>
            //           <td>
            //             {(alertData.CCLOSE - alertData.PCLOSE).toFixed(2)}
            //           </td>
            //           <td>{alertData.ARETURN.toFixed(2)}</td>
            //         </tr>
            //       ))}
            //     </tbody>
            //   </table>
            // </div>
            <>
              <div className="grid-main-box watchlist_gridheight" style={{ display: !NoDataAvailable ? '' : 'none' }}>
                <div style={containerStyle}>
                  <div style={gridStyle} className={"ag-theme-quartz"}>

                    <AgGridReact
                      rowData={watchlistData}
                      rowHeight={30}
                      enableRangeSelection={true}
                      enableCharts={true}
                      columnDefs={columnDefs}
                      suppressDragLeaveHidesColumns={true}
                      animateRows={true}
                      tooltipShowDelay={0}
                      suppressScrollOnNewData={true}
                    />
                  </div>

                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {showWatchlistPopup && (
        <WatchListPopup
          setShowWatchlistPopup={setShowWatchlistPopup}
          showWatchlistPopup={showWatchlistPopup}
          saveChanges={saveChanges}
          setSaveChanges={setSaveChanges}
        />
      )}
    </div>
  );
};
